import React from 'react';
import moment from 'moment';

import { Tag } from '@zola/zola-ui';

import { EntityName, EntityDesciption } from './EditPageCommon/EditPageSortableList';


const EventDetails = (entity) => {
  const event = entity || {};
  const {
    name,
    public: isPublic,
    venue_name: venuName,
    start_at: startAt,
    end_at: endAt,
  } = event;
  const trimmedEventName = name && name.length > 30 ? `${name.slice(0, 30)}...` : name;
  const eventSatrt = moment.utc(startAt).format('ddd, MMM D, YYYY, h:mm a');
  const eventEnd = endAt && moment.utc(event.end_at).format('h:mm a');

  return (
    <>
      <div className="event-visibility">
        <EntityName name={trimmedEventName} />
        <Tag type={`${isPublic ? 'primary' : 'red'} `}>{isPublic ? 'Public' : 'Private'}</Tag>
      </div>
      <EntityDesciption>
        <div className="event-date">{eventSatrt}{eventEnd && ` - ${eventEnd}`}</div>
        <div className="event-venu-name">{venuName}</div>
      </EntityDesciption>
    </>
  )
}

export default EventDetails;



// WEBPACK FOOTER //
// ./src/components/manage/website/entities/EventDetails.jsx